import LocationService from '../services/location.service';
import { SubLocation } from './models/models';

export default {
  namespaced: true,
  state: {
    subLocationId: null,
    isModalOpen: null,
    isNewSubLocation: null,
    totalSubLocations: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
      parentLocationId: null,
    },
  },
  mutations: {
    isModalOpen(state, isOpen) {
      state.isModalOpen = isOpen;
    },
    isNewSubLocation(state, isNewSubLocation) {
      state.isNewSubLocation = isNewSubLocation;
    },
    subLocationId(state, subLocationId) {
      state.subLocationId = subLocationId;
    },
    totalSubLocations(state, totalSubLocations) {
      state.totalSubLocations = totalSubLocations;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
  },
  actions: {
    init({ dispatch }) {
      dispatch('getSubLocations');
    },
    newSubLocation({ commit, dispatch }, parentLocationId) {
      SubLocation.new()
        .then((subLocation) => {
          subLocation.$update({
            parent_location_id: parentLocationId,
          });
          commit('subLocationId', subLocation.id);
          dispatch('openSubLocationModal', {
            id: subLocation.id,
            isNewSubLocation: true,
          });
        });
    },
    openSubLocationModal({ commit }, props) {
      commit('isNewSubLocation', props.isNewSubLocation);
      commit('subLocationId', props.id);
      commit('isModalOpen', true);
    },
    updateSubLocationProps({ state }, props) {
      SubLocation.update({
        where: state.subLocationId,
        data: props,
      });
    },
    getSubLocations({ commit, state, rootState }) {
      const query = { ...state.query };
      query.parentLocationId = rootState.locations.locationId;
      return LocationService.getSubLocations(query)
        .then((res) => {
          commit('totalSubLocations', res.total);
          SubLocation.create({
            data: res.data,
          });
        });
    },
    getSubLocation({ commit }, id) {
      return LocationService.getSubLocation(id)
        .then((warehouse) => {
          SubLocation.insert({ data: [warehouse] })
            .then(() => {
              commit('subLocationId', warehouse.id);
            });
        });
    },
    createSubLocation({ getters }) {
      return LocationService.createSubLocation(getters.subLocation);
    },
    updateSubLocation({ getters, dispatch }) {
      return LocationService.updateSubLocation(getters.subLocation)
        .then((res) => {
          if (res.hasOwnProperty('sub_location_id')) {
            dispatch('getLocation', res.sub_location_id);
          }
          return res;
        });
    },
    clearCurrentSubLocation({ state }) {
      if (state.isNewSubLocation === true) {
        SubLocation.delete(state.subLocationId);
      }
    },
    deleteSubLocation({ getters }) {
      return LocationService.deleteSubLocation(getters.subLocation)
        .then((res) => {
          if (res.hasOwnProperty('sub_location_id')) {
            SubLocation.delete(res.sub_location_id);
          }
          return res;
        });
    },
  },
  getters: {
    subLocations() {
      return SubLocation.query()
        .get();
    },
    subLocation(state) {
      if (!state.subLocationId) {
        return null;
      }
      return SubLocation.query()
        .withAllRecursive()
        .find(state.subLocationId);
    },
  },
};
